import { render, staticRenderFns } from "./Booking6.vue?vue&type=template&id=e55f4396&scoped=true"
import script from "./Booking6.vue?vue&type=script&lang=ts"
export * from "./Booking6.vue?vue&type=script&lang=ts"
import style0 from "./Booking6.vue?vue&type=style&index=0&id=e55f4396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55f4396",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
